<template>
  <div
    class="align-center background-color-white d-flex flex-column pb-5 pt-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold text-center">
      Welcome to {{ wait(storeInfo, "name") }}
    </div>
    <div class="mb-5">Log in with your Phone Number</div>

    <AuthElementsEnterCode :phone="phone" />

    <v-form
      ref="form"
      v-model="valid"
      class="full-width"
      @submit.prevent="validateAndLogin"
    >
      <SMSInput :code="code" :updateCode="updateCode" />
      <AuthElementsSMSResend :phone="phone" :resent="resetForm" />
      <AuthElementsSMSError />
      <v-btn
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          log in
        </div>
      </v-btn>
    </v-form>

    <div class="mt-8">
      Not your number?
      <button @click="toLogInRoute($options.Views.phone)">
        <span class="font-weight-semibold outline-none primary--text"
          >Log in with a different number</span
        >
      </button>
    </div>

    <OrDivider />

    <div class="d-flex full-width justify-space-between mb-4">
      <button @click="toLogInRoute($options.Views.email)">
        <span class="font-weight-semibold outline-none primary--text"
          >Log in with Email</span
        >
      </button>
      <button @click="toAuthRoute('signup')">
        <span class="font-weight-semibold outline-none primary--text"
          >Sign Up</span
        >
      </button>
    </div>
    <div class="full-width">
      <button class="mb-2" @click="toAuthRoute('request')">
        Forgot your password?
        <span class="font-weight-semibold outline-none primary--text"
          >Reset it</span
        >.
      </button>
    </div>
    <div
      class="color-suva-grey font-weight-semibold text-center"
      :class="$vuetify.breakpoint.xsOnly ? 'font-size-xxs' : 'font-size-sm'"
    >
      By tapping the Log In or Sign Up buttons you agree to our:
    </div>
    <LegalLinks :closeAuth="closeAuth" />
  </div>
</template>

<script>
import { Views } from "@/types/login.js";
import { mapState } from "vuex";
import { wait } from "@/util.js";
import AuthElementsEnterCode from "@/components/Auth/Elements/EnterCode.vue";
import AuthElementsSMSResend from "@/components/Auth/Elements/SMSResend.vue";
import AuthElementsSMSError from "@/components/Auth/Elements/SMSError.vue";
import LegalLinks from "@/components/Auth/LogIn/LegalLinks.vue";
import OrDivider from "@/components/Auth/LogIn/OrDivider.vue";
import SMSInput from "@/components/Inputs/SMS.vue";

export default {
  name: "SMSLogInContent",
  components: {
    AuthElementsEnterCode,
    AuthElementsSMSResend,
    AuthElementsSMSError,
    LegalLinks,
    OrDivider,
    SMSInput,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      valid: true,
    };
  },
  methods: {
    validateAndLogin() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.fetchAccountStatus();
    },
    resetForm() {
      [0, 1, 2, 3].forEach((idx) => this.updateCode(idx, null));
      this.$refs.form.resetValidation();
    },
    wait,
  },
  props: {
    closeAuth: Function,
    code: Object,
    fetchAccountStatus: Function,
    phone: String,
    toAuthRoute: Function,
    toLogInRoute: Function,
    updateCode: Function,
  },
  Views,
};
</script>
